import React from 'react';

import { Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { layout, spacing } from 'styles/constants';

export const StaticPageSkeleton = () => {
  return (
    <Box style={styles.container}>
      <Skeleton h="$48" mb="$3" rounded="12" mx="auto" />
      <Skeleton h="$24" mb="$3" rounded="12" mx="auto" />
      <Skeleton h="$24" mb="$3" rounded="12" mx="auto" />
      <Skeleton h="$24" mb="$3" rounded="12" mx="auto" />
      <Skeleton.Text mb="$4" />
      <Skeleton.Text mb="$4" />
      <Skeleton.Text mb="$4" />
      <Skeleton.Text mb="$4" />
      <Skeleton.Text mb="$4" />
      <Skeleton.Text mb="$4" />
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: spacing.$6,
    width: layout.full,
  },
});
